import { InputBase } from "@material-ui/core";
import * as R from "ramda";
import { memo } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { RootState } from "../../store";

const DummyRedirect = memo<{ url: string | null }>(({ url }) => {
  const { register } = useFormContext();

  return (
    <InputBase
      name="redirect"
      inputRef={register}
      value={url}
      style={{ display: "none" }}
    />
  );
});

const ConnectedRedirect = memo<{ url: (state: RootState) => string | null }>(
  ({ url: selectUrl }) => {
    const url = useSelector(selectUrl);

    return <DummyRedirect url={url} />;
  }
);

function isStringValue(
  url: ((state: RootState) => string | null) | string
): url is string {
  return typeof url === "string";
}

export const Redirect = R.ifElse(
  R.compose(isStringValue, R.prop("url")),
  (props) => <DummyRedirect {...props} />,
  (props) => <ConnectedRedirect {...props} />
);
